/**
 * SCRUM-241 — Structura Picking: hub.
 *
 * Solo las dos operaciones del MVP. Nada de dashboard ni métricas: el operario
 * entra con el teléfono en una mano y mercadería en la otra.
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronRight, PackageCheck, Truck } from "lucide-react";
import { PickingShell } from "@/components/picking/PickingShell";

export const Route = createFileRoute("/picking/")({
  component: PickingHub,
  head: () => ({ meta: [{ title: "Structura Picking" }] }),
});

const OPERATIONS = [
  {
    to: "/picking/pedidos",
    icon: PackageCheck,
    title: "Pedidos",
    description: "Preparar pedidos pendientes",
  },
  {
    to: "/picking/recepciones",
    icon: Truck,
    title: "Recepciones",
    description: "Recibir mercadería de proveedores",
  },
] as const;

function PickingHub() {
  return (
    <PickingShell title="Structura Picking">
      {() => (
        <div className="space-y-3">
          {OPERATIONS.map((op) => (
            <Link
              key={op.to}
              to={op.to}
              className="flex items-center gap-4 rounded-lg border border-border bg-card px-4 py-4 active:bg-accent"
            >
              <op.icon className="h-7 w-7 shrink-0 text-primary" />
              <div className="min-w-0 flex-1">
                <p className="text-base font-semibold text-foreground">{op.title}</p>
                <p className="text-xs text-muted-foreground">{op.description}</p>
              </div>
              <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
            </Link>
          ))}
        </div>
      )}
    </PickingShell>
  );
}
